import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { OpenInNew } from "@mui/icons-material";
import { Row } from "components/common";
import { Container, VerticalDivider } from "./styles";
import "./index.css";

const Icon = ({
  imageUrl,
  href,
  hasAbsoluteHref,
  tooltipText,
  onClickAction = () => {},
  icon,
  children,
}) => {
  const history = useHistory();
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const gotoPage = (isAbsolute, href) => {
    if (isAbsolute) {
      window.open(href, "_blank");
    } else {
      history.push(href);
    }
  };
  return (
    <Container onClick={() => gotoPage(hasAbsoluteHref, href)}>
      <div
        style={{
          color: "#3C535C",
          marginRight: "8px",
          transition: "transform 0.4s ease-in-out",
        }}
      >
        {children}
      </div>
      {icon}
    </Container>
  );
};

const AzaraURL = () => {
  if (
    window.location.href.includes("tmtracker-dev") ||
    window.location.href.includes("tmtracker-qa") ||
    window.location.href.includes("localhost")
  )
    return "https://dev-analytics.azara.jllt.com";
  else if (window.location.href.includes("tmtracker-uat"))
    return "https://preprod-analytics.azara.jllt.com";
  else return "https://analytics.azara.jllt.com/";
};

const HOME = {
  // imageUrl: `${cdnUrl}img/Home.svg`,
  icon: <HomeOutlinedIcon sx={{ color: "white" }} fontSize="large" />,
  hasAbsoluteHref: false,
  href: "/",
  tooltipText: "Home",
};
const PAT = {
  // imageUrl: `${cdnUrl}img/line_chart_gray.svg`,
  icon: <AutoGraphIcon sx={{ color: "white" }} fontSize="large" />,
  hasAbsoluteHref: true,
  href: "https://apps.jll.com/pat/Home",
  tooltipText: "PAT TM",
};

const DASHBOARDS = {
  icon: <OpenInNew sx={{ fontSize: 16 }} />,
  hasAbsoluteHref: true,
  href: "https://apps.jll.com/pat/Home",
  tooltipText: "Dashboards",
  label: "Dashboards",
};

const INSIGHTS = {
  icon: <OpenInNew sx={{ fontSize: 16 }} />,
  hasAbsoluteHref: true,
  href: "https://apps.jll.com/pat/Home",
  tooltipText: "Dashboards",
  label: "Dashboards",
};

const AZARA_DASHBOARDS = {
  icon: <OpenInNew sx={{ fontSize: 16 }} />,
  hasAbsoluteHref: true,
  href: AzaraURL(),
  tooltipText: "Dashboards",
  label: "Dashboards",
};

const AZARA_INSIGHTS = {
  icon: <OpenInNew sx={{ fontSize: 16 }} />,
  hasAbsoluteHref: true,
  href: AzaraURL(),
  tooltipText: "Dashboards",
  label: "Dashboards",
};

const Actions = () => {
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const isTMPlus = selectedClient?.isTmPlus;
  const isAzara = selectedClient?.patOrEdpClient === "EDP" ? true : false;
  const actions = [
    isTMPlus
      ? isAzara
        ? AZARA_INSIGHTS
        : INSIGHTS
      : isAzara
      ? AZARA_DASHBOARDS
      : DASHBOARDS,
  ];

  return (
    <div className="header-actions">
      {selectedClient && actions.map((action, index) => (
        <div key={index} style={{ display: "flex" }}>
          <Icon {...action}>{action.label}</Icon>
        </div>
      ))}
    </div>
  );
};

export default Actions;
